import React from 'react'
import { Sidebar } from './Sidebar'

interface MainLayoutProps {
  children: React.ReactNode
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50 flex font-sans antialiased selection:bg-primary-100 selection:text-primary-700">
      {/* Sidebar - Fixed width */}
      <Sidebar />

      {/* Main Content - Offset by sidebar width */}
      <div className="flex-1 ml-72">
        {children}
      </div>
    </div>
  )
}
